<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>创建客户</h4>
        </div>
        <div class="main-bd mg20">
            <el-row>
                <el-col :span="10">
                    <sub-form :model="customer" :submiting="isDisable" @submit="submitForm"></sub-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import CustomerService from "~/services/customer";
import subForm from "~/views/customer/form.vue";

export default {
    components: {
        subForm
    },


    data() {
        return {
            isDisable:false,
            customer: null
        };
    },

    created() {
        this.customer = {
            id: 0,
            name: "",
            show_name: "",
            stages: [],
            type: "",
            level: "3",
            maturity: "",
            memo: "",
            province_id: 0,
            city_id: 0,
            district_id: 0,
            class_num: 0,
            is_visit: 1, // 默认需要回访
            teacher_num: 0,
            origin: ''
        };
    },

    methods: {
        submitForm(customer, reset_form_callback) {
            this.isDisable = true;

            customer.province_id = customer.province_id > 0 ? customer.province_id : '';
            customer.city_id = customer.city_id > 0 ? customer.city_id : '';
            customer.district_id = customer.district_id > 0 ? customer.district_id : '';

            CustomerService.create(customer).then(res => {
                this.isDisable = false;
                if (res.code == 0) {
                    this.$message({
                        message:'创建成功',
                        type:'success'
                    });
                    if (typeof reset_form_callback === 'function') reset_form_callback();
                }
            }).catch(err => {
                this.$message({
                    message:'创建失败！',
                    type:'error'
                });
                this.isDisable = false;
                console.error(err);
            });
        }
    }
    
};
</script>


// WEBPACK FOOTER //
// src/views/customer/create.vue